import React from "react";

const PillBadge = ({ text = "", className = "" }) => {
  return (
    <div className="flex items-center gap-2">
      <span
        className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius ${className}`}
      >
        {text}
      </span>
    </div>
  );
};

export default PillBadge;
